import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { settingsApi } from '../api';
import './Login.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');

  useEffect(() => {
    const fetchCompanySettings = async () => {
      try {
        const res = await settingsApi.getPublic();
        if (res.data && res.data.data) {
          const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
          const BASE_URL = API_URL.replace('/api/v1', '');
          const data = res.data.data;
          if (data.company_logo) {
            setCompanyLogo(`${BASE_URL}${data.company_logo}`);
          }
          if (data.company_name) {
            setCompanyName(data.company_name);
          }
        }
      } catch (err) {
        console.error('Failed to fetch company settings:', err);
      }
    };
    fetchCompanySettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-card">
        <div className="login-logo">
          {companyLogo ? (
            <img src={companyLogo} alt="Company Logo" className="login-logo-img" style={{ width: 80, height: 80, objectFit: 'contain' }} />
          ) : (
            <span className="login-logo-icon">✂</span>
          )}
        </div>
        <h1 className="login-title">{companyName || 'RCITMS'}</h1>
        {companyName && <p className="login-subtitle">Raw Clothing & Tailoring Management</p>}

        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="alert alert-danger">{error}</div>}

          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="admin@rcitms.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="••••••••"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-full btn-lg"
            disabled={loading}
          >
            {loading ? (
              <><span className="spinner" style={{ width: 18, height: 18 }} /> Signing in...</>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="login-demo">
          <p className="text-xs text-muted" style={{ textAlign: 'center', marginBottom: '0.5rem' }}>Demo Credentials</p>
          <div className="demo-creds">
            <div onClick={() => setForm({ email: 'admin@rcitms.com', password: 'Admin@123' })} className="demo-btn">
              <span className="badge badge-admin">Admin</span>
              <span className="text-xs text-muted">admin@rcitms.com</span>
            </div>
            <div onClick={() => setForm({ email: 'manager@rcitms.com', password: 'Manager@123' })} className="demo-btn">
              <span className="badge badge-manager">Manager</span>
              <span className="text-xs text-muted">manager@rcitms.com</span>
            </div>
            <div onClick={() => setForm({ email: 'raju@rcitms.com', password: 'Tailor@123' })} className="demo-btn">
              <span className="badge badge-tailor">Tailor</span>
              <span className="text-xs text-muted">raju@rcitms.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
